export class Renderer {
  constructor(node) {
    this.node = node
  }

  render() {}

  get detail() {
    if (this.node.dataset.detail) {
      return JSON.parse(this.node.dataset.detail)
    } else {
      return {}
    }
  }

  get tooltipText() {
    return ""
  }
}
